module.exports = __webpack_public_path__ + "static/img/App item.94624e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/swiper2/App item.png
// module id = fpAg
// module chunks = 12